<template>
    <form @submit="submitProfileUserdataForm">
        <div class="row mb">
            <div class="col-12">
                <div class="crefo-input">
                    <div class="input-group has-error">
                        <label>{{ t('Formlabels.Salutation') }}</label>
                        <div class="radio-group">
                            <div class="input-wrapper">
                                <div
                                    class="crefo-radio"
                                    data-qa="profileUserdataFormSalutationCodeRadioMS"
                                >
                                    <div class="radio-btn">
                                        <InputText
                                            id="salutation_MS"
                                            v-model="editUser.salutation"
                                            type="radio"
                                            name="salutation"
                                            value="MS"
                                        />
                                        <label for="salutation_MS">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Ms')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="profileUserdataFormSalutationCodeRadioMR"
                                    >
                                        <InputText
                                            id="salutation_MR"
                                            v-model="editUser.salutation"
                                            type="radio"
                                            name="salutation"
                                            value="MR"
                                        />
                                        <label for="salutation_MR">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Mr')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="profileUserdataFormSalutationCodeRadioMX"
                                    >
                                        <InputText
                                            id="salutation_MX"
                                            v-model="editUser.salutation"
                                            type="radio"
                                            name="salutation"
                                            value="MX"
                                        />
                                        <label for="salutation_MX">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t('Formlabels.Salutation.Mx')
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="crefo-radio">
                                    <div
                                        class="radio-btn"
                                        data-qa="profileUserdataFormSalutationCodeRadioUNKNOWN"
                                    >
                                        <InputText
                                            id="salutation_UNKNOWN"
                                            v-model="editUser.salutation"
                                            type="radio"
                                            name="salutation"
                                            value="UNKNOWN"
                                        />
                                        <label for="salutation_UNKNOWN">
                                            <span class="radio-box"
                                            ><span class="radio-box-circle"
                                            /></span>
                                            <span class="radio-label">{{
                                                t(
                                                    'Formlabels.Salutation.Unknown'
                                                )
                                            }}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="errors.salutation" class="error-msg">
                            <span>{{ errors.salutation }}</span>
                        </div>
                    </div>
                </div>
                <div class="crefo-input crefo-ui-select">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.title,
                            'is-valid': !errors.title && values.title
                        }"
                    >
                        <label for="profileUserdataFormTitleCode">{{
                            t('Formlabels.Title')
                        }}</label>
                        <div class="select-group">
                            <div
                                class="input-wrapper"
                                data-qa="profileUserdataFormTitleCodeSelect"
                            >
                                <SelectInput
                                    id="profileUserdataFormTitleCode"
                                    v-model="editUser.title"
                                    name="title"
                                >
                                    <option value="">
                                        {{ t('FormSelect.Choose') }}
                                    </option>
                                    <option
                                        v-for="(item, index) in titleCodes"
                                        :key="'titleCode-' + index"
                                        :value="item.value"
                                    >
                                        {{ item.text }}
                                    </option>
                                </SelectInput>
                            </div>
                        </div>
                        <div v-if="errors.title" class="error-msg">
                            <span>{{ errors.title }}</span>
                        </div>
                    </div>
                </div>
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.givenName,
                            'is-valid': !errors.givenName && values.givenName
                        }"
                    >
                        <label for="profileUserdataFormFirstName">
                            {{ t('Formlabels.FirstName') }}
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="profileUserdataFormFirstName"
                                v-model="editUser.givenName"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.FirstName')"
                                name="givenName"
                                autocomplete="given-name"
                                data-qa="profileUserdataFormFirstNameInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.givenName" class="error-msg">
                            <span>{{ errors.givenName }}</span>
                        </div>
                    </div>
                </div>
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.surName,
                            'is-valid': !errors.surName && values.surName
                        }"
                    >
                        <label for="profileUserdataFormSurname">
                            {{ t('Formlabels.Surname') }}
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="profileUserdataFormSurname"
                                v-model="editUser.surName"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.Surname')"
                                name="surName"
                                autocomplete="family-name"
                                data-qa="profileUserdataFormSurnameInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.surName" class="error-msg">
                            <span>{{ errors.surName }}</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="crefo-input crefo-ui-select">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.birthdayDay,
                                    'is-valid':
                                        !errors.birthdayDay &&
                                        values.birthdayDay
                                }"
                            >
                                <label for="profileUserdataFormBirthdateDay">{{
                                    t('Formlabels.BirthdateDay')
                                }}</label>
                                <div class="select-group">
                                    <div
                                        class="input-wrapper"
                                        data-qa="profileUserdataFormBirthdateDaySelect"
                                    >
                                        <SelectInput
                                            id="profileUserdataFormBirthdateDay"
                                            v-model="editUser.birthdayDay"
                                            name="birthdayDay"
                                        >
                                            <option value="">
                                                {{ t('FormSelect.Choose') }}
                                            </option>
                                            <option
                                                v-for="(item, index) in days"
                                                :key="'days-' + index"
                                                :value="item.value"
                                            >
                                                {{ item.text }}
                                            </option>
                                        </SelectInput>
                                    </div>
                                </div>
                                <div
                                    v-if="errors.birthdayDay"
                                    class="error-msg"
                                >
                                    <span>{{ errors.birthdayDay }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="crefo-input crefo-ui-select">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.birthdayMonth,
                                    'is-valid':
                                        !errors.birthdayMonth &&
                                        values.birthdayMonth
                                }"
                            >
                                <label
                                    for="profileUserdataFormBirthdateMonth"
                                >{{ t('Formlabels.BirthdateMonth') }}</label
                                >
                                <div class="select-group">
                                    <div
                                        class="input-wrapper"
                                        data-qa="profileUserdataFormBirthdateMonthSelect"
                                    >
                                        <SelectInput
                                            id="profileUserdataFormBirthdateMonth"
                                            v-model="editUser.birthdayMonth"
                                            name="birthdayMonth"
                                        >
                                            <option value="">
                                                {{ t('FormSelect.Choose') }}
                                            </option>
                                            <option
                                                v-for="(item, index) in months"
                                                :key="'days-' + index"
                                                :value="item.value"
                                            >
                                                {{ t(item.translationKey) }}
                                            </option>
                                        </SelectInput>
                                    </div>
                                </div>
                                <div
                                    v-if="errors.birthdayMonth"
                                    class="error-msg"
                                >
                                    <span>{{ errors.birthdayMonth }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="crefo-input crefo-ui-select">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.birthdayYear,
                                    'is-valid':
                                        !errors.birthdayYear &&
                                        values.birthdayYear
                                }"
                            >
                                <label for="profileUserdataFormBirthdateYear">{{
                                    t('Formlabels.BirthdateYear')
                                }}</label>
                                <div class="select-group">
                                    <div
                                        class="input-wrapper"
                                        data-qa="profileUserdataFormBirthdateYearSelect"
                                    >
                                        <SelectInput
                                            id="profileUserdataFormBirthdateYear"
                                            v-model="editUser.birthdayYear"
                                            name="birthdayYear"
                                        >
                                            <option value="">
                                                {{ t('FormSelect.Choose') }}
                                            </option>
                                            <option
                                                v-for="(item, index) in years"
                                                :key="'days-' + index"
                                                :value="item.value"
                                            >
                                                {{ item.text }}
                                            </option>
                                        </SelectInput>
                                    </div>
                                </div>
                                <div
                                    v-if="errors.birthdayYear"
                                    class="error-msg"
                                >
                                    <span>{{ errors.birthdayYear }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="crefo-input crefo-ui-select">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid &&
                                        errors.countryDialingCode,
                                    'is-valid':
                                        !errors.countryDialingCode &&
                                        values.countryDialingCode
                                }"
                            >
                                <label
                                    for="profileUserdataFormPhoneCountryCode"
                                >{{
                                    t('Formlabels.PhoneCountryCode')
                                }}</label
                                >
                                <div class="select-group">
                                    <div
                                        class="input-wrapper"
                                        data-qa="profileUserdataFormPhoneCountryCodeSelect"
                                    >
                                        <SelectInput
                                            id="profileUserdataFormPhoneCountryCode"
                                            v-model="
                                                editUser.countryDialingCode
                                            "
                                            name="countryDialingCode"
                                        >
                                            <option value="">
                                                {{ t('FormSelect.Choose') }}
                                            </option>
                                            <option
                                                v-for="(
                                                    item, index
                                                ) in phoneCountryCodes"
                                                :key="'days-' + index"
                                                :value="item.value"
                                            >
                                                {{ item.text }}
                                            </option>
                                        </SelectInput>
                                    </div>
                                </div>
                                <div
                                    v-if="errors.countryDialingCode"
                                    class="error-msg"
                                >
                                    <span>{{ errors.countryDialingCode }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="crefo-input">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.areaDialingCode,
                                    'is-valid':
                                        !errors.areaDialingCode &&
                                        values.areaDialingCode
                                }"
                            >
                                <label for="profileUserdataFormPhoneAreaCode">
                                    {{ t('Formlabels.PhoneAreaCode') }}
                                </label>
                                <div class="input-wrapper">
                                    <InputText
                                        id="profileUserdataFormPhoneAreaCode"
                                        v-model="editUser.areaDialingCode"
                                        data-no-crefo-ui="true"
                                        type="text"
                                        placeholder=""
                                        name="areaDialingCode"
                                        data-qa="profileUserdataFormPhoneAreaCodeInput"
                                        :disabled="submitting"
                                    />
                                    <i
                                        class="crefo-ui-icon icon-check icon-color-blue"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div
                                    v-if="errors.areaDialingCode"
                                    class="error-msg"
                                >
                                    <span>{{ errors.areaDialingCode }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="crefo-input">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.subscriberNumber,
                                    'is-valid':
                                        !errors.subscriberNumber &&
                                        values.subscriberNumber
                                }"
                            >
                                <label for="profileUserdataFormPhoneNumber">
                                    {{ t('Formlabels.PhoneNumber') }}
                                </label>
                                <div class="input-wrapper">
                                    <InputText
                                        id="profileUserdataFormPhoneNumber"
                                        v-model="editUser.subscriberNumber"
                                        type="text"
                                        data-no-crefo-ui="true"
                                        placeholder=""
                                        name="subscriberNumber"
                                        data-qa="profileUserdataFormPhoneNumberInput"
                                        :disabled="submitting"
                                    />
                                    <i
                                        class="crefo-ui-icon icon-check icon-color-blue"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div
                                    v-if="errors.subscriberNumber"
                                    class="error-msg"
                                >
                                    <span>{{ errors.subscriberNumber }}</span>
                                </div>
                            </div>
                        </div>
                        <span class="phone-seperator">&ndash;</span>
                    </div>
                    <div class="col-3">
                        <div class="crefo-input">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.extensionNumber,
                                    'is-valid':
                                        !errors.extensionNumber &&
                                        values.extensionNumber
                                }"
                            >
                                <label
                                    for="profileUserdataFormPhoneExtensionNumber"
                                >
                                    {{ t('Formlabels.ExtensionNumber') }}
                                </label>
                                <div class="input-wrapper">
                                    <InputText
                                        id="profileUserdataFormPhoneExtensionNumber"
                                        v-model="editUser.extensionNumber"
                                        type="text"
                                        placeholder=""
                                        data-no-crefo-ui="true"
                                        name="extensionNumber"
                                        data-qa="profileUserdataFormPhoneExtensionNumberInput"
                                        :disabled="submitting"
                                    />
                                    <i
                                        class="crefo-ui-icon icon-check icon-color-blue"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div
                                    v-if="errors.extensionNumber"
                                    class="error-msg"
                                >
                                    <span>{{ errors.extensionNumber }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.position,
                            'is-valid': !errors.position && values.position
                        }"
                    >
                        <label for="profileUserdataFormPosition">
                            {{ t('Formlabels.Position') }}
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="profileUserdataFormPosition"
                                v-model="editUser.position"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.Position')"
                                name="position"
                                data-qa="profileUserdataFormPositionInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.position" class="error-msg">
                            <span>{{ errors.position }}</span>
                        </div>
                    </div>
                </div>
                <div class="crefo-input">
                    <div
                        class="input-group"
                        :class="{
                            'has-error': !meta.valid && errors.department,
                            'is-valid': !errors.department && values.department
                        }"
                    >
                        <label for="profileUserdataFormDepartment">
                            {{ t('Formlabels.Department') }}
                        </label>
                        <div class="input-wrapper">
                            <InputText
                                id="profileUserdataFormDepartment"
                                v-model="editUser.department"
                                data-no-crefo-ui="true"
                                type="text"
                                :placeholder="t('Formlabels.Department')"
                                name="department"
                                data-qa="profileUserdataFormDepartmentInput"
                                :disabled="submitting"
                            />
                            <i
                                class="crefo-ui-icon icon-check icon-color-blue"
                                aria-hidden="true"
                            />
                        </div>
                        <div v-if="errors.department" class="error-msg">
                            <span>{{ errors.department }}</span>
                        </div>
                    </div>
                </div>
                <div class="row mb">
                    <div class="col-12">
                        <div class="crefo-input crefo-ui-select">
                            <div
                                class="input-group"
                                :class="{
                                    'has-error':
                                        !meta.valid && errors.preferredLanguage,
                                    'is-valid':
                                        !errors.preferredLanguage &&
                                        values.preferredLanguage
                                }"
                            >
                                <label
                                    for="profileUserdataFormPreferredLanguage"
                                >{{
                                    t('Formlabels.PreferredLanguage')
                                }}</label
                                >
                                <div class="select-group">
                                    <div
                                        class="input-wrapper"
                                        data-qa="profileUserdataFormPreferredLanguageSelect"
                                    >
                                        <SelectInput
                                            id="profileUserdataFormPreferredLanguage"
                                            v-model="editUser.preferredLanguage"
                                            name="preferredLanguage"
                                        >
                                            <option
                                                v-if="
                                                    !hasValidPreferredLanguageOption
                                                "
                                                :value="user.preferredLanguage"
                                            >
                                                {{ t('FormSelect.Choose') }}
                                            </option>
                                            <option
                                                v-for="(
                                                    item, index
                                                ) in preferredLanguages"
                                                :key="
                                                    'preferredLanguage-' + index
                                                "
                                                :value="item.value"
                                            >
                                                {{ item.text }}
                                            </option>
                                        </SelectInput>
                                    </div>
                                </div>
                                <div
                                    v-if="errors.preferredLanguage"
                                    class="error-msg"
                                >
                                    <span>{{ errors.preferredLanguage }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="crefo-input">
                            <div class="input-group">
                                <div class="checkbox-group">
                                    <div class="input-wrapper">
                                        <div class="crefo-checkbox">
                                            <InputText
                                                id="profileUserdataFormConsentMarketing"
                                                v-model="
                                                    editUser.consentMarketing
                                                "
                                                type="checkbox"
                                                name="consentMarketing"
                                                data-qa="profileUserdataFormConsentMarketingInput"
                                                :disabled="submitting"
                                                value="1"
                                            />
                                            <label
                                                class="consent"
                                                for="profileUserdataFormConsentMarketing"
                                                data-qa="profileUserdataFormConsentMarketingLabel"
                                                v-html="
                                                    t(
                                                        'Formlabels.ConsentMarketing'
                                                    ) +
                                                        ' ' +
                                                        getConsentDate(
                                                            editUser.consentMarketingLastUpdatedAt
                                                        )
                                                "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="crefo-input">
                            <div class="input-group">
                                <div class="checkbox-group">
                                    <div class="input-wrapper">
                                        <div class="crefo-checkbox">
                                            <InputText
                                                id="profileUserdataFormConsentRecherche"
                                                v-model="
                                                    editUser.consentRecherche
                                                "
                                                type="checkbox"
                                                name="consentRecherche"
                                                data-qa="profileUserdataFormConsentRechercheInput"
                                                :disabled="submitting"
                                                value="1"
                                            />
                                            <label
                                                class="consent"
                                                for="profileUserdataFormConsentRecherche"
                                                data-qa="profileUserdataFormConsentRechercheLabel"
                                            >
                                                {{
                                                    t(
                                                        'Formlabels.ConsentRecherche'
                                                    )
                                                }}
                                                {{
                                                    getConsentDate(
                                                        editUser.consentRechercheLastUpdatedAt
                                                    )
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button
                    type="submit"
                    data-qa="patch-person-submit-button"
                    :disabled="!meta.valid"
                    class="btn btn-default"
                >
                    {{ t('Profile.PersonalData.Form.ButtonText') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script setup>
import moment from 'moment'
import { phoneCountryCodes, structureTelephoneNumber } from '@/helper/phone'
import { years, months, days, extractBirthday } from '@/helper/birthdate'
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useForm } from 'vee-validate'
import InputText from '@/components/customInputs/InputText'
import SelectInput from '@/components/customInputs/SelectInput'
import { getPersonPatch } from '@/helper/personpatch'
import { useUserStore } from '@/store/module-user.js'
import { storeToRefs } from 'pinia'

const schema = {
    title: 'max:255',
    givenName: 'required|max:255',
    surName: 'required|max:255',
    countryDialingCode:
            'validate_phone:countryDialingCode,areaDialingCode,subscriberNumber',
    areaDialingCode:
            'validate_phone:countryDialingCode,areaDialingCode,subscriberNumber|validate_areacode',
    subscriberNumber:
            'validate_phone:countryDialingCode,areaDialingCode,subscriberNumber|validate_numeric',
    extensionNumber: 'validate_numeric',
    birthdayDay:
            'validate_birthdate:birthdayDay,birthdayMonth,birthdayYear',
    birthdayMonth:
            'validate_birthdate:birthdayDay,birthdayMonth,birthdayYear',
    birthdayYear:
            'validate_birthdate:birthdayDay,birthdayMonth,birthdayYear',
    position: 'max:255',
    department: 'max:255',
    preferredLanguage: 'max:255',
    salutation: 'required|included:MS,MR,MX,UNKNOWN'
}

const {
    isSubmitting: submitting,
    meta,
    handleSubmit,
    values,
    errors
} = useForm({
    validationSchema: schema
})
const store = useUserStore()
const { t } = useI18n()

const { internalUser: user } = storeToRefs(store)

const titleCodes = [
    {
        value: 'DR',
        text: t('Formlabels.Title.Dr')
    },
    {
        value: 'PROF',
        text: t('Formlabels.Title.Prof')
    }
]

const preferredLanguages = [
    {
        value: 'de',
        text: t('Formlabels.PreferredLanguage.de')
    },
    {
        value: 'de-AT',
        text: t('Formlabels.PreferredLanguage.de-AT')
    },
    {
        value: 'en',
        text: t('Formlabels.PreferredLanguage.en')
    },
    {
        value: 'fr',
        text: t('Formlabels.PreferredLanguage.fr')
    },
    {
        value: 'fr-LU',
        text: t('Formlabels.PreferredLanguage.fr-LU')
    }
]

const hasValidPreferredLanguageOption = computed(() => {
    return preferredLanguages.some(
        preferredLanguage =>
            preferredLanguage.value === user.value.preferredLanguage
    )
})

const editUser = ref({})

const updateUserBasedOnStore = () => {
    const newUser = user.value

    const {
        dateOfBirth,
        telephoneNumber,
        title,
        preferredLanguage,
        consentMarketing,
        consentRecherche,
        salutation
    } = newUser

    const birthdayData = extractBirthday(dateOfBirth)
    const telephoneData = structureTelephoneNumber(telephoneNumber)

    editUser.value = {
        ...newUser,
        ...birthdayData,
        ...telephoneData,
        title: title || '',
        preferredLanguage: preferredLanguage,
        consentMarketing: consentMarketing === 'GIVEN' ? true : '',
        consentRecherche: consentRecherche === 'GIVEN' ? true : '',
        salutation: salutation ?? 'UNKNOWN'
    }
}
onMounted(() => {
    updateUserBasedOnStore()
})
watch(
    user,
    () => {
        updateUserBasedOnStore()
    },
    { deep: true }
)

const getConsentDate = value => {
    let formattedDate = ''

    if (typeof value === 'string' && value.length) {
        formattedDate = moment(value, 'YYYY-MM-DDTHH:mm:ssZ').format(
            'DD.MM.YYYY'
        )
        formattedDate =
                '(' + t('Formlabels.ConsentDatePrefix') + formattedDate + ')'
    }

    return formattedDate
}

const submitProfileUserdataForm = handleSubmit(() => {
    if (editUser.value?.salutation === 'UNKNOWN') {
        editUser.value.salutation = null
    }

    const patchOperations = getPersonPatch(user.value, editUser.value)

    if (patchOperations && patchOperations.length) {
        store.patchPerson({ patchOperations })
    }
})
</script>

<style scoped lang="less">
    .honey {
        opacity: 0 !important;
        height: 0 !important;
        margin: 0 !important;
        position: absolute !important;
        top: -100px !important;
        left: -100px !important;
    }
    .input-wrapper {
        background-color: #ffffff;
    }
    .radio-label {
        padding-left: 0.5rem !important;
        min-width: 4rem;
        display: inline-block;
    }

    label.consent {
        font-size: 13px;
        line-height: 20px !important;
    }

    input::-webkit-calendar-picker-indicator {
        display: none;
    }

    .phone-seperator {
        display: none;
    }
    @media (min-device-width: 1200px) {
        .phone-seperator {
            font-size: 1.5rem;
            display: inline-block;
            top: 3.4rem;
            position: absolute;
            padding-left: 6px;
            color: #b5b5b5;
            right: -5px;
        }
    }
</style>
